import React from "react";
import {
  NavLink as RouterLink,
  useLocation,
} from "react-router-dom";

import {
  Button,
  List,
  ListItemButton,
  ListItem,
  Typography,
  Divider,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Collapse from "@mui/material/Collapse";

const UserManagementDropdown = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const splitLoc = splitLocation[3];
  const splitLoc1 = splitLocation[2];

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      {localStorage.getItem("group") === "admin" || localStorage.getItem("group") === "ops_users" ? (
        <div>
          <ListItemButton
            disableGutters
            sx={{
              display: "flex",
              py: 0.5,
              pl: 1,
            }}
            onClick={handleClick}
          >
            <Typography color="white" variant="h6">
              User Management
            </Typography>
            {open ? (
              <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
            ) : (
              <ArrowDropDownIcon
                style={{ marginLeft: "auto", color: "white" }}
              />
            )}
          </ListItemButton>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
            <List component="div" disablePadding>
              <li className="px-3 rounded-lg mb-1 text-gray-700">
                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "addtrainees"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/organization"
                  >
                    <span>Overview</span>
                  </Button>
                </ListItem>

                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "assigntrainer"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/users"
                  >
                    <span>Users</span>
                  </Button>
                </ListItem>
                
                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "assigntrainer"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/groups"
                  >
                    <span>Groups</span>
                  </Button>
                </ListItem>
                
                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "bulkuser"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/bulkuser"
                  >
                    <span>Bulk User creation</span>
                  </Button>
                </ListItem>
                
                {/* <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "management"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/management"
                  >
                    <span>old User Management</span>
                  </Button>
                </ListItem> */}
               
              </li>
            </List>
          </Collapse>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default UserManagementDropdown;
